export const greenCommentImageUrl = 'https://res.cloudinary.com/dfbebf7x0/image/upload/v1662204850/green-comment_cceopa.svg'
export const redCommentImageUrl = 'https://res.cloudinary.com/dfbebf7x0/image/upload/v1662203212/red-comment_ot3beb.svg'
export const redMicrophoneImageUrl = 'https://res.cloudinary.com/dfbebf7x0/image/upload/v1662217445/red-microphone_s9qyvb.svg'
export const greenMicrophoneImageUrl = 'https://res.cloudinary.com/dga8cqcsp/image/upload/v1664863179/ImgIcons/green-mic_ggrvn5.svg'


